import React, { useState } from "react";
import { Container, Modal, Button, Card, Row, Col, Image } from 'react-bootstrap';
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import LazyLoad from "react-lazy-load";

import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import QuotesIcon from "../images/icon/testimonial-quotes-icon.svg";

const ClientsTestimonial = ({
  title = "<span class='text-muted'>What</span> <span class='text-primary'>Our Customers Say</span> <span class='text-muted'>Today,</span><br />You will Say Tomorrow",
  description = "We have another voice that advocates our work along with us. And those voices are of our esteemed clients. They fell in love with our service and spent their valuable time praising us. See what they have to say about us.",
  sectionClass = 'bg-light',
}) => {

  const TestimonialRodrigoTrindade = '../images/testimonials/testimonials-rodrigo-trindade.png';
  const TestimonialPedroSarmento = '../images/testimonials/testimonials-pedro-sarmento.png';
  const TestimonialPauloRibeiro = '../images/testimonials/testimonials-paulo-ribeiro.png';
  // const VideoIcon = '../images/video-icon.png';

  const ClientsTestimonial = [
    {
      keyname: "testimonial1",
      name: "Rodrigo Trindade",
      post: "Real-estate App, Brazilian",
      des: "It was an amazing experience partnering with Peerbits. They were not only committed to our project but also developed an app that we desired.",
      url: "https://www.youtube.com/embed/sPPUW7yZB84"
    },
    {
      keyname: "testimonial2",
      name: "Pedro Sarmento",
      post: "ACC (Airlines) App, Portugal",
      des: "Peerbits was worth choosing for our airline business's digital transformation. The team's skill, communication, knowledge - everything was exceptional.",
      url: "https://www.youtube.com/embed/xqlwBHfhzy8"
    },
    {
      keyname: "testimonial3",
      name: "Paulo Ribeiro",
      post: "VP, Smartex.ai, Portugal",
      des: "Thanks to Peerbits for building a powerful automated fabric inspection system that helped us achieve high textile quality. Their amazing team support & expertise boosted our growth by 10x.",
      url: "https://www.youtube.com/embed/rwlk7AP9Ujc"
    }
  ];

  const [keyName, setKeyName] = useState('');
  const [liveUrl, setLiveUrl] = useState('');

  const openModal = (item) => {
    setLiveUrl(item.url);
    setKeyName(item.keyname);
  };

  const closeModal = () => {
    setKeyName('');
    setLiveUrl('');
  };

  return (
    <section className={`section clients-testimonial-section ${sectionClass}`}>
      <Container className="py-5">
        <div className="mb-4 pb-1">
          <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
          <p className="max-width-950 lead">{description}</p>
        </div>
        <Card>
          <Card.Body>
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              className="testimonial-swiper"
            >
              {ClientsTestimonial.map((item, index) => (
                <SwiperSlide key={index}>

                  <Row className="g-5">
                    <Col xs={12} md={12} lg='auto'>
                      <LazyLoad offset={300}>
                        <div className="testimonial-img-bg" onClick={() => openModal(item)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              openModal(item);
                            }
                          }}
                          role="button"
                          tabIndex="0">
                          {item.keyname === "testimonial1" && (
                            <StaticImage loading="lazy" className="testimonial-img" src={TestimonialRodrigoTrindade} width={412} height={330} alt="Testimonial Thumb" />
                          )}
                          {item.keyname === "testimonial2" && (
                            <StaticImage loading="lazy" className="testimonial-img" src={TestimonialPedroSarmento} width={412} height={330} alt="Testimonial Thumb" />
                          )}
                          {item.keyname === "testimonial3" && (
                            <StaticImage loading="lazy" className="testimonial-img" src={TestimonialPauloRibeiro} width={412} height={330} alt="Testimonial Thumb" />
                          )}
                        </div>
                      </LazyLoad>
                    </Col>
                    <Col>
                      <div className="d-flex flex-column h-100">
                        <div className="testimonial-content my-auto">
                          <Image loading="lazy" className="mb-5 lazyload" src={QuotesIcon} width={72} height={50} alt="testimonial-quotes-icon" />
                          <p className="lead m-0">
                            {item.des}
                          </p>
                          <hr className="mb-4" />
                        </div>
                        <Row>
                          <Col xs={8} lg={12}>
                            <h3 className="h4 mb-1 font-size-24">{item.name}</h3>
                            <p className="mb-0">{item.post}</p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Modal size="xl" show={item.keyname === keyName} onHide={closeModal} centered>
                    <Modal.Body>
                      <div className="text-end video-close-btn">
                        <Button variant="" className="btn-close" onClick={closeModal}></Button>
                      </div>
                      <div className="ratio ratio-16x9">
                        <iframe
                          className="lazyload"
                          loading="lazy"
                          src={liveUrl}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </Modal.Body>
                  </Modal>
                </SwiperSlide>
              ))}
            </Swiper>
          </Card.Body>
        </Card>
        <div className="text-center mt-4 pt-4">
          <Link to="/testimonials.html" className="btn btn-link">
            <span>View more testimonials</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default ClientsTestimonial;
